module.exports = __webpack_public_path__ + "img/topazinho-1.3674341a.png";